import { defineComponent as _defineComponent } from 'vue';
import NavLink from '@/Components/Navigation/NavLink.vue';
import { usePage } from '@inertiajs/inertia-vue3';
import ResponsiveNavLink from './ResponsiveNavLink.vue';
export default /*#__PURE__*/ _defineComponent({
    __name: 'CompanyMenuItem',
    props: {
        routeName: String,
        icon: String,
        responsive: {
            type: Boolean,
            default: false,
        },
    },
    setup(__props, { expose }) {
        expose();
        const props = __props;
        const page = usePage();
        const user = page.props.value.auth.user;
        const company = page.props.value.company;
        const isAdmin = user.admin;
        const routeNamePrefix = isAdmin ? 'admin.companies.' : '';
        const routeName = routeNamePrefix + props.routeName;
        const navLinkComponent = props.responsive ? ResponsiveNavLink : NavLink;
        const __returned__ = { props, page, user, company, isAdmin, routeNamePrefix, routeName, navLinkComponent };
        Object.defineProperty(__returned__, '__isScriptSetup', { enumerable: false, value: true });
        return __returned__;
    }
});
